module.exports = __webpack_public_path__ + "img/solar_lock-password-linear.d041a42f.svg";